import { FormattedMessage } from 'react-intl';

const SectionSeparator = (props) => {
  return <div className='section-separator position-relative pt-4'>
    <h4>
      <span><FormattedMessage id={props.title} /></span>
    </h4>
    <hr className="position-absolute w-100 border-accent-2 mt-28 mb-24" />
  </div>
}
export default SectionSeparator;